import cloneDeep from "lodash/cloneDeep";
import isEmpty from "lodash/isEmpty";
import IncidentsHelper from "../helpers/incidentsHelper";
import store from "../store/store";
import type {
  EventIncidentType,
  EventMarketPeriodType,
  EventMarketWSType,
  EventRunnerWSType,
  EventType,
} from "../types/eventType";
export default class EventLogic {
  static updateEvent(eventUpdatesWS: EventType[]) {
    let eventList: EventType[] = cloneDeep(
      store.getState().eventListModel.eventList
    );
    let singleEvent: EventType = cloneDeep(
      store.getState().singleEventModel.singleEvent
    );
    eventUpdatesWS.forEach(eventUpdateWS => {
      // Update the event list
      let event = eventList.find(event => event.id === eventUpdateWS.id);

      if (event != null) {
        updateEventData(event, eventUpdateWS);
        store.dispatch.eventListModel.updateEventInList(event);
      }

      // Update the event in the event detail screen
      if (singleEvent != null) {
        if (singleEvent.id === eventUpdateWS.id) {
          updateEventData(singleEvent, eventUpdateWS);
          store.dispatch.singleEventModel.setEvent(singleEvent);
        }
      }
    });
  }

  static updateMarket(marketUpdates: EventMarketWSType[]) {
    let singleEvent: EventType = cloneDeep(
      store.getState().singleEventModel.singleEvent
    );
    marketUpdates.forEach(marketUpdate => {
      // SINGLE EVENT
      // Update the event in the mobile event detail screen
      //
      if (singleEvent != null && singleEvent.marketPeriods != null) {
        let foundMarketPeriod = singleEvent.marketPeriods.find(
          mp => mp.marketPeriod === marketUpdate.period
        );

        if (foundMarketPeriod != null) {
          let foundMarketType = foundMarketPeriod.marketTypes.find(
            mt => mt.marketType === marketUpdate.type
          );

          if (foundMarketType != null) {
            let foundMarket = foundMarketType.markets.find(
              m => m.id === marketUpdate.id
            );

            if (foundMarket != null) {
              foundMarket.status = marketUpdate.status;
              // update event singleEventModel with WS market update
              store.dispatch.singleEventModel.setEvent(singleEvent);
            }
          }
        }
      }

      if (
        store.getState().competitionListModel.unsummarizedMarketsModalEvent &&
        store.getState().competitionListModel.unsummarizedMarketsModalEvent
          .marketPeriods != null
      ) {
        let modalEvent: EventType = cloneDeep(
          store.getState().competitionListModel.unsummarizedMarketsModalEvent
        );
        let foundMarketPeriod = modalEvent.marketPeriods.find(
          mp => mp.marketPeriod === marketUpdate.period
        );

        if (foundMarketPeriod != null) {
          let foundMarketType = foundMarketPeriod.marketTypes.find(
            mt => mt.marketType === marketUpdate.type
          );

          if (foundMarketType != null) {
            let foundMarket = foundMarketType.markets.find(
              m => m.id === marketUpdate.id
            );

            if (foundMarket != null) {
              foundMarket.status = marketUpdate.status;
              store.dispatch.competitionListModel.updateUnsummarizedMarketsModalEvent(
                modalEvent
              );
            }
          }
        }
      }
    });
  }

  static updateRunner(runnerUpdatesWS: EventRunnerWSType[]) {
    let eventList: EventType[] = cloneDeep(
      store.getState().eventListModel.eventList
    );
    let singleEvent: EventType = cloneDeep(
      store.getState().singleEventModel.singleEvent
    );
    runnerUpdatesWS.forEach(runnerUpdateWS => {
      // EVENT LIST
      // Update the event list with runner status update
      let event = eventList.find(
        event => event.id === runnerUpdateWS["eventId"]
      );

      if (event != null && !isEmpty(event.markets)) {
        let foundMarket = event.markets.find(
          x => x.id === runnerUpdateWS["marketId"]
        );

        if (foundMarket != null) {
          let foundRunner = foundMarket.runners.find(
            runner => runner.id === runnerUpdateWS.id
          );

          if (foundRunner != null) {
            foundRunner.status = runnerUpdateWS.status;
            // update event eventListModel with WS runner update
            store.dispatch.eventListModel.updateEventInList(event);
          }
        }
      }

      // SINGLE EVENT
      // update event details view with runner updates
      if (singleEvent != null && singleEvent.marketPeriods != null) {
        let marketDetails = getMarketDetails(
          singleEvent.marketPeriods,
          runnerUpdateWS
        );
        let foundMarketPeriod = singleEvent.marketPeriods.find(
          mp => mp.marketPeriod === marketDetails.marketPeriod
        );

        if (foundMarketPeriod != null) {
          let foundMarketType = foundMarketPeriod.marketTypes.find(
            mt => mt.marketType === marketDetails.marketType
          );

          if (foundMarketType != null) {
            let foundMarket = foundMarketType.markets.find(
              m => m.id === runnerUpdateWS["marketId"]
            );

            if (foundMarket != null) {
              let foundRunner = foundMarket.runners.find(
                r => r.id === runnerUpdateWS.id
              );

              if (foundRunner != null) {
                foundRunner.status = runnerUpdateWS.status;
                // update event singleEventModel with WS runner update
                store.dispatch.singleEventModel.setEvent(singleEvent);
              }
            }
          }
        }
      }
    });
  }

  static updateEventIncident(eventIncidentUpdatesWS: EventIncidentType[]) {
    // Used in event details on mobile
    let singleEvent: EventType = cloneDeep(
      store.getState().singleEventModel.singleEvent
    );
    eventIncidentUpdatesWS.forEach(eventIncidentUpdateWS => {
      if (singleEvent != null) {
        if (
          singleEvent.id === eventIncidentUpdateWS["eventId"] &&
          singleEvent["eventIncidents"] != null
        ) {
          IncidentsHelper.updateEventIncidentData(
            singleEvent,
            eventIncidentUpdateWS
          );
          store.dispatch.singleEventModel.setEvent(singleEvent);
        }
      }
    });
  }
}
/*
 ** INTERNAL METHODS
 */
// update event data

function updateEventData(event: EventType, eventUpdate: EventType) {
  event["allowLiveBetting"] = eventUpdate["allowLiveBetting"];
  event["inRunning"] = eventUpdate["inRunning"];
  event["numberOfMarkets"] = eventUpdate["numberOfMarkets"];
  event["startTime"] = eventUpdate["startTime"];
  event.status = eventUpdate.status;
}

// find marketPeriod and marketType to find correct market for runner
function getMarketDetails(
  marketPeriods: EventMarketPeriodType[],
  runnerUpdateWS: EventRunnerWSType
) {
  const marketDetails = {
    marketPeriod: "",
    marketType: "",
  };
  marketPeriods.forEach(marketPeriod => {
    marketPeriod.marketTypes.forEach(marketType => {
      marketType.markets.forEach(market => {
        // check if market matches runner market id
        if (market.id === runnerUpdateWS["marketId"]) {
          marketDetails.marketPeriod = marketPeriod.marketPeriod;
          marketDetails.marketType = marketType.marketType;
        }
      });
    });
  });
  return marketDetails;
}
